import { normalizeMapDocument, type MapDocument } from "@west-marches/shared";
import type { RichTextDocument } from "@/components/editor/types";
import { normalizeNoteContent } from "@/components/notes/noteContent";

const PENDING_CLOUD_ONBOARDING_KEY = "west-marches-map.pending-cloud-onboarding";

export interface PendingCloudOnboarding {
  campaignName: string;
  displayName: string;
  email: string;
  document: MapDocument;
  anonymousNotebookContent?: RichTextDocument;
  createdAt: string;
}

function canUseLocalStorage(): boolean {
  return typeof window !== "undefined" && "localStorage" in window;
}

export function loadPendingCloudOnboarding(): PendingCloudOnboarding | null {
  if (!canUseLocalStorage()) {
    return null;
  }

  const raw = window.localStorage.getItem(PENDING_CLOUD_ONBOARDING_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as PendingCloudOnboarding;
    return {
      ...parsed,
      document: normalizeMapDocument(parsed.document),
      anonymousNotebookContent: parsed.anonymousNotebookContent
        ? normalizeNoteContent(parsed.anonymousNotebookContent)
        : undefined,
    };
  } catch {
    return null;
  }
}

export function hasPendingCloudOnboarding(): boolean {
  if (!canUseLocalStorage()) {
    return false;
  }
  return window.localStorage.getItem(PENDING_CLOUD_ONBOARDING_KEY) !== null;
}

export function savePendingCloudOnboarding(payload: PendingCloudOnboarding): void {
  if (!canUseLocalStorage()) {
    return;
  }

  window.localStorage.setItem(PENDING_CLOUD_ONBOARDING_KEY, JSON.stringify(payload));
}

export function clearPendingCloudOnboarding(): void {
  if (!canUseLocalStorage()) {
    return;
  }

  window.localStorage.removeItem(PENDING_CLOUD_ONBOARDING_KEY);
}
